module.exports = __webpack_public_path__ + "static/media/adaptability.bef0b1e9.svg";